import React, { useEffect, useState } from "react";

import { overviewData } from "../../../shared/settings/apiConfig";
import { getApi } from "../../../shared/services/apiHelper";

import './Home.scss';
import { AppLoader } from "../../../shared/components/Loader";

const getOverview = (completedCount, openCount) => {
    return [
        {
            name: "Assessments Completed",
            count: completedCount,
            // subname: "Requires Retest:",
            // subcount: 2,
            color: "#f5f1fe"
        },
        {
            name: "Assessments Currently Open",
            count: openCount,
            // subname: "Overdue",
            // subcount: 0,
            color: "#f0f9ff"
        },
        {
            name: "Performance Rating",
            count: renderStar(),
            type: "rateBase",
            color: "#ffc9e2"
        }
    ];
};

const renderStar = () => {
    return (
        <div>
            <span className="fa fa-star star checked"></span>
            <span className="fa fa-star star checked"></span>
            <span className="fa fa-star star checked"></span>
            <span className="fa fa-star star"></span>
            <span className="fa fa-star star"></span>
        </div>
    );
};

export const AssesseDahboard = (props) => {

    const [overview, setOverview] = useState(getOverview(0, 0));
    const [isLoading, setIsLoading] = useState(false);

    // const [graphChart, setGraphChart] = useState([
    //     {
    //         label: 'Series 1',
    //         data: [[0, 1], [1, 2], [2, 4], [3, 2], [4, 7]]
    //     },
    //     {
    //         label: 'Series 2',
    //         data: [[0, 3], [1, 1], [2, 5], [3, 6], [4, 4]]
    //     }
    // ]);

    useEffect(() => {
        setIsLoading(true);
        getApi(overviewData).then(response => {
            setOverview(getOverview(response.data.data.completedassessments, response.data.data.openassessments));
            setIsLoading(false);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    return (
        <div>
            <text className='screen-head'>Dashboard</text>
            <div className='d-flex align-items-center p-3 gap-2'>
                <img style={{ width: "1.5rem", height: "1.5rem" }} src={`${process.env.PUBLIC_URL}/static/images/dashboard.png`} alt={"editing"} />
                <text className='font-weight-bold m-0'>Overview</text>
            </div>
            {
                isLoading ? <AppLoader /> : 

                <div className="home-container">
                    <div className="d-flex gap-3 px-3 py-2">
                        {
                            overview.map((item, index) => (
                                <div key={'dashboard-card-' + index} className="p-4 shadow w-100" style={{ backgroundColor: item.color, borderRadius: "0.3rem", flex: '1 0' }}>
                                    <div className="d-flex">
                                        <div style={{ flex: "1 0" }}>
                                            <text className="font-weight-bold text-l">{item.name}</text>
                                            <div className='dashboard-count'>{item.count}</div>
                                        </div>
                                        <div>
                                            {/* <div className="border rounded border-skyblue p-2">
                                                <img style={{ width: '1.5rem' }} src={`${process.env.PUBLIC_URL}/static/images/${item.icon}.png`} alt={item?.name} />
                                            </div> */}
                                        </div>
                                    </div>
                                    {
                                        item.type == "rateBase" ? null :
                                            item.subname ?
                                                <div className="d-flex gap-1 text-s">
                                                    <div style={{ fontWeight: "bolder" }}>{`${item.subname}:`} </div>
                                                    <div style={{ fontWeight: "bolder" }} className="text-primary">{item.subcount} </div>
                                                </div> : null
                                    }
                                </div>
                            ))
                        }
                    </div>
                </div>
            }
            
        </div>
    );

}